import Bme280Diagram from "../../../../docs/_images/hw_ff_bme280.png";
import Bme280Schematics from "../../../../docs/_images/hw_ff_bme280_schem.png";
import * as React from 'react';
export default {
  Bme280Diagram,
  Bme280Schematics,
  React
};